const states = [
    {
        value: 'ACT',
        displayText: 'ACT',
    },
    {
        value: 'NSW',
        displayText: 'NSW',
    },
    {
        value: 'VIC',
        displayText: 'VIC',
    },
    {
        value: 'QLD',
        displayText: 'QLD',
    },
    {
        value: 'WA',
        displayText: 'WA',
    },
    {
        value: 'NT',
        displayText: 'NT',
    },
    {
        value: 'SA',
        displayText: 'SA',
    },
    {
        value: 'TAS',
        displayText: 'TAS',
    },
];

export default states;
